// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__2s6bG","vLegacy":"SelectSecondary_vLegacy__3MRAp","error":"SelectSecondary_error__32e9A","disabled":"SelectSecondary_disabled__2onqT"};